import { useEffect, useState } from "react";
import { FileText, Loader2, Paperclip } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function useReceiptUrl(path) {
  const [url, setUrl] = useState(null);
  const [type, setType] = useState("");
  useEffect(() => {
    if (!path) return;
    let obj;
    api.get(`/files/${path}`, { responseType: "blob" }).then((r) => { obj = URL.createObjectURL(r.data); setType(r.data.type); setUrl(obj); }).catch(() => setUrl(""));
    return () => obj && URL.revokeObjectURL(obj);
  }, [path]);
  return { url, type };
}

export function ReceiptThumb({ path, onClick, testid }) {
  const { url, type } = useReceiptUrl(path);
  if (!path) return null;
  return (
    <button type="button" data-testid={testid} onClick={onClick} className="group relative h-10 w-10 shrink-0 overflow-hidden rounded-md border border-slate-200 bg-slate-50 transition-transform hover:scale-105">
      {url === null && <Loader2 className="m-auto mt-2.5 h-4 w-4 animate-spin text-slate-400" />}
      {url && type.startsWith("image/") && <img src={url} alt="" className="h-full w-full object-cover" />}
      {url && !type.startsWith("image/") && <FileText className="m-auto mt-2.5 h-5 w-5 text-slate-500" />}
      {url === "" && <Paperclip className="m-auto mt-2.5 h-4 w-4 text-slate-400" />}
    </button>
  );
}

export function ReceiptPreview({ expense, onClose }) {
  const { t } = useLang();
  const { url, type } = useReceiptUrl(expense?.receipt_path);
  return (
    <Dialog open={!!expense} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="receipt-preview-dialog" className="max-w-3xl">
        <DialogHeader><DialogTitle className="font-display">{t("receipt")} — {expense?.vendor} · <span className="font-mono text-base text-slate-500">{expense?.date}</span></DialogTitle></DialogHeader>
        <div className="flex min-h-[300px] items-center justify-center rounded-lg bg-slate-100 p-2">
          {url === null && <Loader2 className="h-6 w-6 animate-spin text-slate-400" />}
          {url && type.startsWith("image/") && <img data-testid="receipt-preview-image" src={url} alt="receipt" className="max-h-[70vh] w-auto rounded object-contain" />}
          {url && !type.startsWith("image/") && <iframe data-testid="receipt-preview-pdf" title="receipt" src={url} className="h-[70vh] w-full rounded" />}
          {url === "" && <p className="text-sm text-slate-500">{t("error")}</p>}
        </div>
        {url && <a href={url} download data-testid="receipt-download-link" className="text-xs font-semibold text-[#007A3D] hover:underline">{t("download")}</a>}
      </DialogContent>
    </Dialog>
  );
}
